export const NOT_USED_STATE = 3;

export const CLOSED_STATE = 7;
export const CANCELED_STATE = 8;
export const ANUL_STATE = 9;

export const ERROR_STATE = 4;
export const INCORRECT_STATE = 19;

export const stateMessages = {
    [CLOSED_STATE]: 'Согласие на ОПД уже отправлено',
    [CANCELED_STATE]: 'Отказ в предоставлении согласия на ОПД',
    [ANUL_STATE]: 'Ссылка аннулирована',
};

export const errorMessages = {
    [INCORRECT_STATE]: 'Ссылка недействительна',
    [ERROR_STATE]: 'Ссылка недействительна',
    error: 'Не удалось соединиться с сервером. Попробуйте еще раз.',
};
